export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const ROYALTIES_LIST = 'ROYALTIES_LIST'
export const DASHBOARDDATA_LIST = 'DASHBOARDDATA_LIST'
export const OWNEDSONGSHARES_LIST = 'OWNEDSONGSHARES_LIST'
export const OPENSONGSHARES_LIST = 'OPENSONGSHARES_LIST'
export const ROYALTY_CHART_DATA = 'ROYALTY_CHART_DATA'
export const SONGSHARES_LIST = 'SONGSHARES_LIST'
export const INVESTMENT_CHART_DATA = 'INVESTMENT_CHART_DATA'
